/** @jsxImportSource @emotion/react */
import { Text } from "basis";

export const CantFind = () => (
  <div>
    <Text color="primary.blue.t100">
      <b>Can't find your address?</b>
    </Text>
  </div>
);
